var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudGrayMd = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 180,
  height: 136,
  fill: "none",
  viewBox: "0 0 180 136",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 64,
  r: 64,
  fill: "var(--utility-gray-200, black)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 20,
  r: 6,
  fill: "var(--utility-gray-100, black)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 112,
  r: 8,
  fill: "var(--utility-gray-100, black)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 36,
  r: 8,
  fill: "var(--utility-gray-100, black)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 9,
  r: 5,
  fill: "var(--utility-gray-100, black)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd_1182_2026)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-50, black)",
  d: "M92 16c-13.466 0-25.378 6.654-32.627 16.854A32 32 0 0 0 52 32c-17.673 0-32 14.327-32 32s14.327 32 32 32h80c15.464 0 28-12.536 28-28s-12.536-28-28-28a28 28 0 0 0-3.248.186C122.623 25.96 108.475 16 92 16"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 64,
  r: 32,
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 56,
  r: 40,
  fill: "url(#b)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 68,
  r: 28,
  fill: "url(#c)"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_b_1182_2026)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-400, black)",
  d: "M62 88c0-15.464 12.536-28 28-28s28 12.536 28 28-12.536 28-28 28-28-12.536-28-28"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m100.5 98.5-4.083-4.083m2.916-7c0 5.477-4.44 9.916-9.916 9.916-5.477 0-9.917-4.44-9.917-9.916 0-5.477 4.44-9.917 9.917-9.917s9.916 4.44 9.916 9.917"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 27.429,
  x2: 84,
  y1: 42.857,
  y2: 96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0D5DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "var(--utility-gray-200, black)",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 61.286,
  x2: 132,
  y1: 29.571,
  y2: 96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0D5DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "var(--utility-gray-200, black)",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 110.5,
  x2: 160,
  y1: 49.5,
  y2: 96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0D5DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "var(--utility-gray-200, black)",
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudGrayMd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CloudGrayMd.808dba9d288f2f9e21caf482ba301588.svg";